import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css"; // For Reactstrap

const getInitials = (name) => {
  if (!name) return "";
  const parts = name.trim().split(" ");
  return parts.map((n) => n[0]).join("").toUpperCase().slice(0, 2);
};

const UserDetailsModal = ({ isOpen, toggle, user }) => {
    if (!user) {
        return (
            <Modal isOpen={isOpen} toggle={toggle} centered>
                <ModalHeader toggle={toggle}>User Details</ModalHeader>
                <ModalBody>
                    <div className="text-center text-muted">
                        No user data available.
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        {user.firstName + " " + user.middleName + " " + user.lastName}
      </ModalHeader>
      <ModalBody>
        {user && (
          <div className="card shadow-sm border-0">
            <div className="card-body d-flex">
              <div className="me-4">
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center bg-secondary text-white"
                  style={{
                    width: "80px",
                    height: "80px",
                    fontSize: "28px",
                    overflow: "hidden",
                  }}
                >
                  {user.photo ? (
                    <img
                      src={user.photo}
                      alt={user.name}
                      className="img-fluid rounded-circle"
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    getInitials(user.name)
                  )}
                </div>
              </div>
              <div>
                <h5 className="card-title mb-2">{user.name}</h5>
                <ul className="list-unstyled mb-0">
                  <li>
                    <strong>First Name:</strong> {user.firstName}
                  </li>
                  <li>
                    <strong>Last Name:</strong> {user.lastName}
                  </li>
                  {user.middleName && (
                    <li>
                      <strong>Middle Name:</strong> {user.middleName}
                    </li>
                  )}
                  <li>
                    <strong>Role:</strong> {user.role}
                  </li>
                  <li>
                    <strong>Organization:</strong> {user.organization}
                  </li>
                  <li>
                    <strong>Client Name:</strong> {user.clientName}
                  </li>
                  <li>
                    <strong>Event Name:</strong> {user.eventName}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UserDetailsModal;
